import { replaceAccents } from '@framework/cookbook/string.utils';

import {
    type GroupRecord,
    type MemberRecord
} from '@components/layout/AccessManagement/AccessManagement.interface';

export function devError(message: string) {
    if (process.env.NODE_ENV !== 'production' && console !== undefined) {
        // eslint-disable-next-line no-console
        console.error(`Dev Error: ${message}`);
    }
}

export function devWarn(message: string) {
    if (process.env.NODE_ENV !== 'production' && console !== undefined) {
        // eslint-disable-next-line no-console
        console.warn(`Dev Warning: ${message}`);
    }
}

export const filterGroups = (id: string, groupsById: GroupRecord, search: string) => {
    const group = groupsById[id];

    const normalizedGroupName: string = replaceAccents(group.name);
    const normalizedGroupInitials: string = replaceAccents(group.initials);

    const splitName: string[] = normalizedGroupName.split(/[\s-]+/);

    const initialsStartsWithSearch = normalizedGroupInitials.startsWith(search);
    const nameStartsWithSearch = normalizedGroupName.startsWith(search);
    const splitNameStartsWithSearch = splitName.some((name) => name.startsWith(search));

    return initialsStartsWithSearch || nameStartsWithSearch || splitNameStartsWithSearch;
};

export const filterMembers = (id: string, membersById: MemberRecord, search: string) => {
    const user = membersById[id]?.user;
    const { email, firstName, lastName } = user;

    const normalizedFirstName: string = replaceAccents(firstName);
    const normalizedFullName: string = replaceAccents(`${firstName} ${lastName}`);
    const normalizedLastName: string = replaceAccents(lastName);

    const splitName: string[] = normalizedFullName.split(/[\s-]+/);

    const emailStartsWithSearch = email.toLowerCase().startsWith(search);
    const firstNameStartsWithSearch = normalizedFirstName.startsWith(search);
    const fullNameStartsWithSearch = normalizedFullName.startsWith(search);
    const lastNameStartsWithSearch = normalizedLastName.startsWith(search);
    const splitNameStartsWithSearch = splitName.some((name) => name.startsWith(search));

    return (
        emailStartsWithSearch ||
        firstNameStartsWithSearch ||
        fullNameStartsWithSearch ||
        lastNameStartsWithSearch ||
        splitNameStartsWithSearch
    );
};
